import { QBS_DETAILS_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { QBankStructureStatusTag } from '@exam-management/components';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { Navigate } from '@exam-management/router';
import { Divider, Flex, PageHeader, Text } from '@shared/components';
import { capitalize, formatDateTime } from '@shared/utils';

import { QBankStructureHeaderMenu } from '../qbank-structure-header-menu';
import { QBankStructureNavigationTabs } from '../qbank-structure-navigation-tabs';

export default function QBankStructureDetailHeader() {
  const { qBankStructureInformation } = useQBankStructure();

  if (!qBankStructureInformation) {
    return <Navigate to='/qbank-structures' replace />;
  }

  return (
    <PageHeader
      title={qBankStructureInformation.name}
      subtitleSection={
        <>
          <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
            <Text
              variant='body2'
              color='text.secondary'
              data-testid={QBS_DETAILS_DATA_TEST_ID.COURSE_ID_TEXT}
            >
              Course ID: {qBankStructureInformation.code}
            </Text>
            <Text
              variant='body2'
              color='text.secondary'
              data-testid={QBS_DETAILS_DATA_TEST_ID.TYPE_TAG}
            >
              Type: {capitalize(qBankStructureInformation.type)}
            </Text>
          </Flex>
          <Text variant='body2' color='text.secondary'>
            {`Last Modified: ${formatDateTime(qBankStructureInformation.updatedAt)}`}
          </Text>
        </>
      }
      endAdornment={
        <Flex sx={{ gap: (theme) => theme.spacing(4), alignItems: 'center' }}>
          <QBankStructureStatusTag
            status={qBankStructureInformation.status}
            size='large'
            data-testid={QBS_DETAILS_DATA_TEST_ID.STATUS_TAG}
          />
          <Divider
            orientation='vertical'
            flexItem
            sx={{ width: 'unset', my: (theme) => theme.spacing(1) }}
          />
          <QBankStructureHeaderMenu />
        </Flex>
      }
      tabs={<QBankStructureNavigationTabs />}
    />
  );
}
